import React, { PropsWithChildren } from 'react';
import { ProgressBar } from '../../../../../components/ProgressBar';
import clsx from 'clsx';

interface LoadingWrapperProps {
  loading: boolean;
  component?: React.ReactFragment;
  className?: string;
  title?: string;
  message?: string;
  size?: SizeVariant;
  bordered?: boolean;
  height?: number;
}

export const LoadingWrapper = ({
  children,
  className,
  loading,
  component,
  title = 'Loading Content',
  message = 'This will only take a moment...',
  size = 'medium',
  bordered = false,
  height,
}: PropsWithChildren<LoadingWrapperProps>) => {
  if (!loading) return <React.Fragment>{children}</React.Fragment>;

  if (component) return <React.Fragment>{component}</React.Fragment>;

  return (
    <div
      className={clsx(
        'flex flex-col items-center h-full rounded p-6 w-full',
        className,
        {
          'border tg-border-color': bordered,
        }
      )}
      style={{ height }}
    >
      <div className="flex flex-col items-center justify-center gap-4 max-w-[500px] w-full h-full">
        <div className="w-full">
          <p
            className={clsx('font-bold', {
              'text-sm': size === 'small',
              'text-lg': size === 'medium',
              'text-xl': size === 'large',
            })}
          >
            {title}
          </p>
          <span
            className={clsx('opacity-70', {
              'text-xs': size === 'small',
              'text-sm': size === 'medium',
              'text-base': size === 'large',
            })}
          >
            {message}
          </span>
        </div>
        <ProgressBar indeterminate />
      </div>
    </div>
  );
};
